export class ExchangeRate {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.facilityId = params.facility_id ? params.facility_id : null
    this.exchangeRate = params.exchange_rate ? params.exchange_rate : null
  }
}
